window.itemImages = function itemImages() {

    'use strict';

    var alt_mobile_overlay,
        overlay_padding = 30;

    if ($('.js_heritageItem').length) {
        alt_mobile_overlay = $('.js_heritageItem').data('alt-mobile-overlay-layout');
        overlay_padding = 0;
    } else {
        alt_mobile_overlay = '';
    }

    // Load images
    if ($('.js_itemImages').length || $('.js_heritageItem').length) {

        let overlay_close_button,
            custom_arrow = $('.js_customSlickArrow');

        function itemImageSlider(direction) {
            let item_image_slider = $('.itemImageSlider');

            item_image_slider.slick({
                lazyLoad: 'ondemand',
                dots: false,
                arrows: true,
                nextArrow: '<a class="slick-next"><img src="/sites/petervardy/images/svgs/angle-right-regular.svg" alt="Next Image"/></a>',
                prevArrow: '<a class="slick-prev"><img src="/sites/petervardy/images/svgs/angle-left-regular.svg" alt="Previous Image"/></a>'
            });

            if (direction) {
                item_image_slider.slick(direction);
                custom_arrow.remove();
            }
        }

        custom_arrow.on('click', function (e) {
            e.preventDefault();
            let direction = $(this).data('direction');
            itemImageSlider(direction);
        });

        if ($('.heritageItem').length <= 0) {
            overlay_close_button = '<div class="overlayCloseButton"><a href="#"> <span>Close</span> <img class="itemImagesPopupCloseSVG" src="/sites/petervardy/images/svgs/close.svg" alt="Close Popup" /></a></div>';
        } else {
            overlay_close_button = '<div class="overlayCloseButton"><a href="#"> <img src="/sites/petervardy/images/svgs/close.svg" alt="Close Popup"/></a></div>'
        }

        $(document).on('click', '.productImageOverlay', function (e) {
            e.preventDefault();

            if (matchesMediaQuery(671) || $('.js_heritageItem').length) {
                var href = $(this).attr('href');
                $('.js_productImageOverlay').attr({'href': href}).trigger('click');
            }
        });

        // item image overlay slider
        $('.js_productImageOverlay').mtcOverlay({
            contentClass: 'itemImageOverlay ' + alt_mobile_overlay,
            padding: overlay_padding,
            buttonHtml: overlay_close_button,
            beforeOpen: function () {
                $('.largeImageSlider').slick({
                    lazyLoad: 'ondemand',
                    fade: true,
                    dots: false,
                    arrows: true,
                    nextArrow: '<a class="slick-next"><img src="/sites/petervardy/images/svgs/angle-right-regular.svg" alt="Next Image"/></a>',
                    prevArrow: '<a class="slick-prev"><img src="/sites/petervardy/images/svgs/angle-left-regular.svg" alt="Previous Image"/></a>',
                    initialSlide: $('.largeImageSlider').data('initialslide'),
                    asNavFor: '.pagerSlider',
                    adaptiveHeight: true
                });


                $('.pagerSlider').slick({
                    slidesToShow: 10,
                    slidesToScroll: 1,
                    asNavFor: '.largeImageSlider',
                    dots: false,
                    arrows: false,
                    centerMode: false,
                    focusOnSelect: true,
                    responsive: [
                        {
                            breakpoint: 1300,
                            settings: {
                                slidesToShow: 6
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 8
                            }
                        },
                        {
                            breakpoint: 670,
                            settings: {
                                slidesToShow: 6
                            }
                        }
                    ]
                });

                $('.overlayBox .js_personalisedFormOverlay').on('click', function (e) {
                    killclick(e);
                    $('.overlayCloseButton').trigger('click');

                    setTimeout(function () {
                        $('.item .js_personalisedFormOverlay').first().trigger('click');
                    }, 500);
                });

                $(document).on('keydown', function (e) {

                    var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0;

                    if (key === 37) {
                        $('.overlayBox .slick-prev').trigger('click');
                    } else if (key === 39) {
                        $('.overlayBox .slick-next').trigger('click');
                    }
                });

                // scroll to link within overlay - close the overlay
                $('body').on('click', '.js_scrollTo', function () {
                    $('.overlayCloseButton').trigger('click');
                });

                $('.overlayBox .enquireOverlay').on('click', function (e) {
                    killclick(e);
                    $('.overlayCloseButton').trigger('click');


                    // wait until overlay is closed then trigger orginal button
                    setTimeout(function () {
                        $('.item .enquireOverlay').first().trigger('click');
                    }, 500);

                });
            }
        });
    }
}

window.srp_slider = function srp_slider() {
    const srp_slider = $(".js_srp_slider");

    if (srp_slider.length > 0) {
        srp_slider.slick({
            lazyLoad: 'ondemand',
            fade: true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            nextArrow: '<a class="slick-next"><img src="/sites/petervardy/images/svgs/angle-right-regular.svg" alt="Next Image"/></a>',
            prevArrow: '<a class="slick-prev"><img src="/sites/petervardy/images/svgs/angle-left-regular.svg" alt="Previous Image"/></a>',
        });
    }
}

$(document).ready(function () {
    'use strict';

    itemImages();

    const fpa_slider = $(".js_fpa_slider");

    if (fpa_slider.length > 0) {
        if (matchesMediaQuery(671)) {
            fpa_slider.slick({
                lazyLoad: 'ondemand',
                fade: true,
                dots: false,
                arrows: true,
                nextArrow: '<a class="slick-next"><img src="/sites/petervardy/images/svgs/angle-right-regular.svg" alt="Next Image"/></a>',
                prevArrow: '<a class="slick-prev"><img src="/sites/petervardy/images/svgs/angle-left-regular.svg" alt="Previous Image"/></a>',
                initialSlide: $('.largeImageSlider').data('initialslide'),
                asNavFor: '.pagerSlider',
                adaptiveHeight: true
            });
        }
    }

    $('.item').on('click', '.js_triggerImageOverlay', function (e) {
        killclick(e);
        $('.largeImage .productImageOverlay').first().trigger('click');
    });

    if ($('.js_mobileImageOverlayBtn').length) {
        $('.js_mobileImageOverlayBtn').mtcOverlay({
            contentClass: 'mobileImageOverlay',
            buttonHtml: '<div class="overlayCloseButton mobileImageOverlayClose"><a href="#"><img src="/sites/petervardy/images/svgs/times-light-white.svg" alt="Close Popup" /></a></div>'
        });
    }
});